import { z } from 'zod';
import { moduleSearchSchema } from '@/features/modules/shared/module-search.schema';

/**
 * Search params das rotas do currículo. Herdam o contexto da vaga
 * (`vagaId`/`phaseId`) e, na rota de adicionar, a etapa (RN-10: escolher o tipo
 * é tela própria) e o tipo escolhido — na URL para o Voltar do browser funcionar
 * e para um reload cair na etapa certa sem gravar nada (CUR-011).
 *
 * EU-762: `rota` = caminho escolhido na entrada (`perfil` | `pdf`), levado até
 * "Salvar currículo" para o log de gerações (RN-15).
 */
export const resumeSearchSchema = moduleSearchSchema.extend({
  etapa: z.enum(['tipo', 'formulario']).optional(),
  tipo: z.string().max(40).optional(),
  rota: z.enum(['perfil', 'pdf']).optional(),
});

export type ResumeSearch = z.infer<typeof resumeSearchSchema>;
